import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import CepTemplateSelectorForm from 'components/CepTemplateSelectorForm/CepTemplateSelectorForm';
import Heading from 'components/Heading';
import MayaLayout from 'components/MayaLayout';
import Box from 'yoda-ui/components/Box';

const CepTemplateSelector: FC = () => {
  const { t } = useTranslation();

  return (
    <MayaLayout>
      <Box height='80px'>
        <Heading>
          { t('maya_choose_cep_template_heading') }
        </Heading>
      </Box>

      <CepTemplateSelectorForm />
    </MayaLayout>
  );
};

export default CepTemplateSelector;
